import { combineReducers } from '@reduxjs/toolkit';
import user from './User';
import app from './AppStore'
import product from './Product'
import tree from './Tree'
// import enum from './Enum'
import staticData from './StaticData'

const appReducers = combineReducers({
  user,
  app,
  product,
  tree,
  staticData
});

export default appReducers;